export default __webpack_public_path__ + "media/images/features/saga/balloon_challenge-b941020e3dc27693fad1973fc67a5b14.jpg";